import * as e from "./index.es302.js";
import { getAugmentedNamespace as r } from "./index.es224.js";
const o = /* @__PURE__ */ r(e);
export {
  o as default
};
//# sourceMappingURL=index.es225.js.map
